export const requiredErrorMessage = "Please fill in this required field";
